import React from "react";

const REASONS = [
  "Spam or scam",
  "Harassment or bullying",
  "Hate speech or violence",
  "Sexual content",
  "Personal information leak",
  "Other"
];

export default function ReportMessageDialog({ open, onClose, onSubmit, messageText }) {
  const [reason, setReason] = React.useState(REASONS[0]);
  const [details, setDetails] = React.useState("");

  if (!open) return null;

  return (
    <div className="report-dialog-overlay" onClick={onClose}>
      <div className="report-dialog-content" onClick={e => e.stopPropagation()}>
        <h3 className="report-dialog-title">Report Message</h3>
        
        <div className="report-message-preview">
          "{messageText}"
        </div>

        <div className="report-form-group">
          <label>Reason for reporting</label>
          <select 
            value={reason} 
            onChange={e => setReason(e.target.value)} 
            className="report-select"
          >
            {REASONS.map(r => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>

        <div className="report-form-group">
          <label>Details (optional)</label>
          <textarea
            value={details}
            onChange={e => setDetails(e.target.value)}
            placeholder="Help our moderators understand the issue..."
            className="report-textarea"
            rows={3}
          />
        </div>

        <div className="report-dialog-actions">
          <button onClick={onClose} className="report-btn-cancel">Cancel</button>
          <button 
            onClick={() => onSubmit({ reason, details })} 
            className="report-btn-submit"
          >
            Submit Report
          </button>
        </div>

        <style>
          {`
            .report-dialog-overlay {
              position: fixed;
              top: 0; left: 0; right: 0; bottom: 0;
              background: rgba(0, 0, 0, 0.4);
              backdrop-filter: blur(4px);
              z-index: 3000;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 20px;
            }

            .report-dialog-content {
              background: whitesmoke;
              border-radius: var(--border-radius);
              padding: 24px;
              width: 100%;
              max-width: 400px;
              box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
              border: 1px solid rgba(0,0,0,0.05);
              font-family: var(--primary-font);
              color: var(--text-color);
            }

            .report-dialog-title {
              margin-top: 0;
              margin-bottom: 16px;
              font-family: var(--secondary-font);
              font-weight: 700;
              font-size: 1.5rem;
            }

            .report-message-preview {
              background: rgba(0, 0, 0, 0.05);
              padding: 12px;
              border-radius: 8px;
              font-size: 0.9rem;
              font-style: italic;
              margin-bottom: 20px;
              max-height: 80px;
              overflow-y: auto;
              border-left: 3px solid var(--color3);
            }

            .report-form-group {
              margin-bottom: 16px;
            }

            .report-form-group label {
              display: block;
              font-size: 0.85rem;
              font-weight: 700;
              margin-bottom: 6px;
              opacity: 0.8;
            }

            .report-select, .report-textarea {
              width: 100%;
              padding: 10px;
              border-radius: 8px;
              border: 2px solid var(--color4);
              background: white;
              color: var(--text-color);
              font-family: var(--primary-font);
              font-size: 0.95rem;
              outline: none;
              transition: border-color 0.2s;
            }

            .report-select:focus, .report-textarea:focus {
              border-color: var(--color3);
            }

            .report-textarea {
              resize: none;
            }

            .report-dialog-actions {
              display: flex;
              gap: 12px;
              justify-content: flex-end;
              margin-top: 24px;
            }

            .report-btn-cancel, .report-btn-submit {
              padding: 10px 20px;
              border-radius: 20px;
              border: none;
              font-weight: 700;
              cursor: pointer;
              transition: all 0.2s;
              font-size: 0.9rem;
            }

            .report-btn-cancel {
              background: transparent;
              color: var(--text-color);
              opacity: 0.6;
            }

            .report-btn-cancel:hover {
              opacity: 1;
              background: rgba(0,0,0,0.05);
            }

            .report-btn-submit {
              background: var(--error-color);
              color: whitesmoke;
            }

            .report-btn-submit:hover {
              transform: translateY(-1px);
              box-shadow: 0 4px 12px rgba(175, 62, 62, 0.3);
            }

            @media (prefers-color-scheme: dark) {
              .report-dialog-content {
                background: color-mix(in srgb, var(--bg-color), black 85%);
                border-color: rgba(255, 255, 255, 0.05);
              }
              .report-select, .report-textarea {
                background: color-mix(in srgb, var(--bg-color), black 80%);
                border-color: var(--color3);
                color: whitesmoke;
              }
              .report-message-preview {
                background: rgba(255, 255, 255, 0.05);
              }
              .report-btn-cancel {
                color: whitesmoke;
              }
            }
          `}
        </style>
      </div>
    </div>
  );
}